module.exports = __webpack_public_path__ + "img/TO.ba2127cb.svg";